export const ADD_CALENDAR_MODAL_FIELDS = {
  CHECKED_CALENDARS: 'checkedCalendars',
  CHECKED_CALENDARS_ADD: 'checkedCalendarsAdd',
  CALENDAR: 'calendar',
};
